import React, { Suspense, lazy } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';

import Loading from './components/Loading/Loading.jsx';
import { Switch, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop.js';
import PaymentSuccess from './pages/Payments/PaymentSuccess.js';
import PaymentFail from './pages/Payments/PaymentFail.js';
import { XERO_ENABLED } from './lib/featureFlags';

const Login = lazy(() => import('./pages/Login/Login.jsx'));
const Signup = lazy(() => import('./pages/Login/Signup.jsx'));
const ConfirmAccount = lazy(() => import('./pages/Login/ConfirmAccount.jsx'));
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard.jsx'));
const Chat = lazy(() => import('./pages/Chat/Chat.jsx'));
const TeamBilling = lazy(() => import('./pages/Dashboard/TeamBilling.jsx'));
const Alerts = lazy(() => import('./pages/Dashboard/Alerts.jsx'));
const Activity = lazy(() => import('./pages/Dashboard/Activity.jsx'));
const Privacy = lazy(() => import('./pages/privacy/privacy.jsx'));
const Eula = lazy(() => import('./pages/Eula/eula.jsx'));
const Tos = lazy(() => import('./pages/TermsOfService/tos.jsx'));
const Notfound = lazy(() => import('./pages/notfound.jsx'));
const SignoutQBO = lazy(() => import('./pages/signoutQBO/signoutQBO.jsx'));
const Callback = lazy(() => import('./pages/Login/Callback.jsx'));
const StartOAuth = lazy(() => import('./pages/Login/StartOAuth.jsx'));
const XeroCallback = lazy(() => import('./pages/Login/XeroCallback.jsx'));
const StartXeroOAuth = lazy(() => import('./pages/Login/StartXeroOAuth.jsx'));
const Disconnect = lazy(() => import('./pages/disconnect/disconnect.jsx'));
const Env = lazy(() => import('./pages/Env.jsx'));
const FAQ = lazy(() => import('./pages/FAQ.jsx'));
const WhatsNew = lazy(() => import('./pages/WhatsNew.jsx'));

function App() {
  // Root Class Should Only Be Used To Route
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path="/" component={Dashboard} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/confirm" component={ConfirmAccount} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/chat" component={Chat} />
            <Route exact path="/team/billing" component={TeamBilling} />
            <Route exact path="/team/alerts" component={Alerts} />
            <Route exact path="/activity" component={Activity} />
            <Route exact path="/privacy-policy" component={Privacy} />
            <Route exact path="/tos" component={Tos} />
            <Route exact path="/eula" component={Eula} />
            <Route exact path="/signoutQBO" component={SignoutQBO} />
            <Route exact path="/callback" component={Callback} />
            <Route exact path="/startoauth" component={StartOAuth} />
            {XERO_ENABLED && <Route exact path="/xero/callback" component={XeroCallback} />}
            {XERO_ENABLED && <Route exact path="/startxeroauth" component={StartXeroOAuth} />}
            <Route exact path="/disconnect" component={Disconnect} />
            <Route exact path="/payment_success" component={PaymentSuccess} />
            <Route exact path="/payment_fail" component={PaymentFail} />

            <Route exact path="/env" component={Env} />
            <Route exact path="/faq" component={FAQ} />
            <Route exact path="/whats-new" component={WhatsNew} />

            <Route exact component={Notfound} />
          </Switch>
        </Suspense>
      </div>
    </BrowserRouter>
  );
}

export default App;
